import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeavesRoutingModule } from './leaves-routing.module';
import { ListComponent } from './list/list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeavesReportComponent } from './leaves-report/leaves-report.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PipeModule } from 'app/shared/pipes/pipe.module';


@NgModule({
  declarations: [
    ListComponent,
    LeavesReportComponent
  ],
  imports: [
    CommonModule,
    LeavesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule, 
    MatMenuModule,
    NgSelectModule,
    NgbModule,
    NgxSpinnerModule,
    PipeModule
  ]
})
export class LeavesModule { }
